import { Modal } from 'bootstrap'
import { ddlGenericInitialise } from 'slim-select-prefabs'
import { datepicker } from 'flatpickr-prefabs'

const orderTableDataTableInitialise = () => {
    new JSTable('#OrderTable', {
        columns: [{ select: 6, sortable: false }],
        labels: {
            noRows: 'No data available in table'
        },
        perPage: 20
    })
}
const populateVendorContacts = () => {
    const ddlVendorContactID = document.querySelector('.ddlVendorContactID') as HTMLFormElement
    const hidGetVendorContact = document.getElementById('hidGetVendorContact') as HTMLFormElement
    const ddlVendorID = document.querySelector('.ddlVendorID') as HTMLFormElement
    if (ddlVendorContactID != null) {
        ddlVendorContactID.innerHTML = ''
    }
    fetch(
        `${hidGetVendorContact.value.toString()}?id=${encodeURIComponent(
            ddlVendorID.value.toString()
        )}`,
        {
            method: 'POST'
        }
    )
        .then((response) => response.json())
        .then((result) => {
            result.forEach((elem: any) => {
                const opt = document.createElement('option')
                opt.value = elem.Value
                opt.innerHTML = elem.Text
                ddlVendorContactID.appendChild(opt)
            })
            ddlGenericInitialise()
        })
        .catch((ex) => {
            alert(`Failed to retrieve contacts.${ex}`)
        })
}
const initialise = () => {
    const hidGetOrdersList = document.getElementById('hidGetOrdersList') as HTMLFormElement
    const hidViewOrder = document.getElementById('hidViewOrder') as HTMLFormElement
    fetch(
        hidGetOrdersList.value.toString(),
        {
            method: 'POST'
        }
    )
        .then((response) => response.json())
        .then((result) => {
            const tableId = document.getElementById('OrderTable')
            let tBody = tableId!.getElementsByTagName('tbody')[0]
            if (tBody !== undefined) {
                tableId!.removeChild(tBody)
            }
            tableId!.appendChild(document.createElement('tbody'))
            tBody = tableId!.getElementsByTagName(
                'tbody'
            )[0] as HTMLTableSectionElement
            result.forEach((elem: any) => {
                tBody.insertAdjacentHTML(
                    'beforeend',
                    `<tr><td>${elem.OrdersNumber
                    }</td><td>${elem.Vendor
                    }</td><td>${elem.Product
                    }</td><td>${elem.PalomaInitials
                    }</td><td>${elem.ClientName
                    }</td><td>${elem.OrdersID
                    }<td><a href='${hidViewOrder.value.toString()
                    }/${elem.OrdersID
                    }' class='btn btn-success'>View</a></td></tr>`
                )
            })
            orderTableDataTableInitialise()
        })
    const btnAddNewOrder = document.querySelector('.btnAddNewOrder') as HTMLFormElement
    if (btnAddNewOrder != null) {
        btnAddNewOrder.addEventListener('click', () => {
            const newOrderDiv = document.querySelector(
                '.NewOrder'
            ) as HTMLFormElement
            const newOrder = new Modal(newOrderDiv, {
                backdrop: true,
                keyboard: true
            })
            ddlGenericInitialise()
            datepicker()
            const ddlVendor = document.getElementById('ddlVendorID') as HTMLFormElement
            if (ddlVendor != null) {
                ddlVendor.addEventListener('change', () => {
                    populateVendorContacts()
                    return false
                })
            }
            newOrder.show()
        })
    }
}
window.addEventListener('load', () => {
    initialise()
})
